import React, { useEffect, useState } from "react";
import DTOSetSalaryARModal from "./DTOSetSalaryARModal";
import SetSalaryARModalPresenter from "./SetSalaryARModalPresenter";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../infra/hooks";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";
import toast from "react-hot-toast";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  fullData?: any;
}

const SetSalaryARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
}: ModalInterface) => {
  const [daActions, setDaActions] = useState([]);
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);

  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOSetSalaryARModal setAllActions={(act: any) => setDaActions(act)} />

      <SetSalaryARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        fullData={fullData}
        allActions={daActions}
        userId={selector.user_id}
        handleSubmitAR_Request={hitAction}
      />
    </div>
  );
};

export default SetSalaryARModalController;
